import React from 'react'
import { NavLink } from 'react-router-dom'
import aboutus from '../assets/about_us.png'

const About = () => {
  return (
    <>
      <div className="container">
        <div className="row my-5">
          <div className="col-md-6">
            <h1 className='text-dark fw-bold mb-4 text-secondary '>About Us</h1>
            <p className="lead mb-b text-dark">
              Lorem ipsum dolor sit amet consectetur adipisicing elit. Harum
              enim quisquam ut, eius maxime sit deserunt vitae modi alias
              distinctio assumenda ad adipisci numquam et veritatis sed nihil.
              Est a vel vero omnis vitae illo nobis voluptatem maxime natus
              temporibus. Dolor pariatur quidem ab similique provident ad
              eveniet architecto distinctio eligendi quam voluptate dolore
              recusandae mollitia, quae explicabo amet sit. Ad laudantium cumque
              tempora, natus fugit mollitia eius. Velit error corrupti
              cupiditate, praesentium dolorem magni rem accusamus! Eos sequi
              vero, est sit fugit ex? Aspernatur odio dolorem dolore earum
              facere adipisci ipsum distinctio unde nostrum in? Minus labore
              voluptates facilis?
            </p>
            <NavLink to='/Contact' className="btn btn-outline-dark mt-5 px-5">Contact Us</NavLink>
          </div>
          <div className="col-md-6">
            <img src="https://img.freepik.com/free-vector/teamwork-concept-landing-page_52683-20165.jpg?w=740&t=st=1680869412~exp=1680870012~hmac=be519439734916425ea79ed100b59b1748ea5806391f0082179bce65ea9ec566" alt="about_us" height={500} width={550}/>
          </div>
        </div>
      </div>
    </>
  )
}

export default About
